<template>
  <span class="widget-info-button-wrap">
    <button
      :id="targetId"
      type="button"
      class="widget-info-button"
      :aria-label="`Show logic for ${title}`"
      @click.stop
    >
      i
    </button>
    <b-popover
      :target="targetId"
      triggers="hover focus click"
      placement="auto"
      custom-class="widget-logic-popover"
    >
      <template #title>{{ title }} Logic</template>
      <div class="widget-info-content">{{ logic }}</div>
    </b-popover>
  </span>
</template>

<script>
import { BPopover } from 'bootstrap-vue';

export default {
  name: 'WidgetInfoButton',
  components: {
    BPopover,
  },
  props: {
    targetId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    logic: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.widget-info-button-wrap {
  display: inline-flex;
  align-items: center;
}

.widget-info-button {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  padding: 0;
}

.widget-info-button:hover,
.widget-info-button:focus {
  background: rgba(255, 255, 255, 0.3);
  outline: none;
}

.widget-info-content {
  max-width: 320px;
  white-space: normal;
  line-height: 1.35;
}
</style>
